import React, {Fragment} from 'react';
import {Props} from '../Builder/ElementProperties';

const VideoElement = (props) => {
	const url = Props.getMediaURL({props});
	return (
		<video 
			width={props.element.width}
			height={props.element.height}
			controls={props.element.showControls} 
			autoPlay={!props.builder && props.element.autoPlay} 
			onPlay={e =>{
				props.experiment.recordEvent({eventType:'Media Event', actionType:'video.play', screenId:props.experiment.currentScreen.id, elementId:props.element.id, elementType:'video', value: 'play' });
				props.experiment.forceUpdate();
			}}
			onPause={e =>{
				props.experiment.recordEvent({eventType:'Media Event', actionType:'video.pause', screenId:props.experiment.currentScreen.id, elementId:props.element.id, elementType:'video', value: 'pause' });
				props.experiment.forceUpdate();
			}}
			onEnded={e =>{
				props.experiment.recordEvent({eventType:'Media Event', actionType:'video.end', screenId:props.experiment.currentScreen.id, elementId:props.element.id, elementType:'video', value: 'end' });
				Props.onClickHandler({props, field:'onEnd'});
			}}
		>
			<source src={url} type="video/mp4" />
			Your browser does not support the video tag.
		</video>
	);
}

const Properties = (props) => (
	<Fragment>
		<Props.Id {...props} />
		<Props.X {...props} />
		<Props.Y {...props} />
		<Props.Width {...props} />
		<Props.Height {...props} />
		<Props.URL {...props} />
		<Props.ShowControls {...props} />
		<Props.AutoPlay {...props} />
		<Props.OnEnd {...props} />
	</Fragment>
);

VideoElement.type = 'video';
VideoElement.Properties = Properties;
VideoElement.defaultJSON = {type: 'video', id:'New Video', x: 250, y:250, width:320, height:240, 
url:'http://jonnymoon.com/videos/Family_Videos_2014/1_2014/Jane%20the%20little%20monkey.mp4', onEnd:'', showControls:'true', autoPlay:''
};
export default VideoElement;


// WEBPACK FOOTER //
// ./src/components/ScreenElements/VideoElement.js